<template>
  <div class="article_list" v-loading="loading">
    <el-form ref="form" :model="form" class="form_box" :inline="true">
      <el-form-item label="发布状态:">
        <el-select v-model="form.status" placeholder="请选择" :clearable="true">
          <el-option
            v-for="item in statusList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="标签:" class="account_select">
        <el-cascader
          v-model="tagList"
          :options="options"
          :props="tagProps"
          collapse-tags
          :show-all-levels="false"
        ></el-cascader>
      </el-form-item>
      <el-form-item label="关键词:">
        <el-input v-model="form.title" placeholder="请输入关键词" clearable />
      </el-form-item>
      <el-form-item label="作者:">
        <el-input v-model="form.author" placeholder="请输入关键词" clearable />
      </el-form-item>
      <el-form-item label="操作时间:">
        <el-date-picker
          v-model="searchTime"
          :unlink-panels="true"
          type="daterange"
          :clearable="true"
          :editable="false"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        />
      </el-form-item>

      <el-button type="primary" @click="searchList" class="filter_btn">筛选</el-button>
    </el-form>
    <el-row class="btn_row" type="flex" justify="space-between">
      <el-col :span="12">
        <el-button type="primary" :disabled="!Boolean(sortList.length)" @click="verifyArticleList">
          发布到企业应用
        </el-button>
      </el-col>
      <el-col :span="4" style="text-align: right">
        <el-button type="primary" @click="createMessage">新建内容</el-button>
      </el-col>
    </el-row>
    <el-table
      :data="tableData"
      style="width: 100%"
      class="table_row"
      :row-class-name="tableRowDisabled"
      @selection-change="handleSelectionChange"
      @select="hanldeSelect"
      ref="table"
    >
      <el-table-column type="selection" width="55" :selectable="selectable"></el-table-column>
      <el-table-column label="内容" width="400">
        <template slot-scope="scope">
          <div class="article_content">
            <el-image
              class="cover_pic"
              :class="{ unpublished: scope.row.status === 1 }"
              :src="scope.row.cover_list_url"
            ></el-image>
            <div class="article_info">
              <div class="article_title">{{ scope.row.title }}</div>
              <div class="label_list">
                <span class="product" v-for="(product, index) in scope.row.tags" :key="index">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="product.product_name"
                    popper-class="user_select_text"
                    placement="top"
                  >
                    <div class="hidden_text">{{ product.product_name || '-' }}</div>
                  </el-tooltip>
                </span>
                <!-- <span class="hidden_text">{{ scope.row.description || '-' }}</span> -->
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="scope.row.id.toString()"
                  popper-class="user_select_text"
                  placement="top"
                >
                  <span class="hidden_text">ID：{{ scope.row.id }}</span>
                </el-tooltip>
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="使用范围" width="150">
        <template slot-scope="scope">
          <div class="app_roll">
            <div v-for="(item, index) in scope.row.art_agent_list" :key="index">
              {{ item.agent_name }}
            </div>
            <div v-if="scope.row.art_agent_list == 0">暂无适用应用</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="create_time" label="操作时间">
        <template slot-scope="scope">
          {{ scope.row.update_time }}
        </template>
      </el-table-column>
      <el-table-column prop="updateUser" label="操作者"></el-table-column>
      <el-table-column prop="status" label="发布状态">
        <template slot-scope="scope">
          {{ statusData[scope.row.status] || scope.row.status }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200px">
        <template slot-scope="scope">
          <el-button type="text" @click="editCol(scope.row)">编辑</el-button>
          <el-button type="text" @click="viewRecord(scope.row)">记录</el-button>
          <el-popover placement="bottom" width="200" trigger="click">
            <div @mouseleave="closeCopyLink">
              <div>
                <div style="display: inline-block; width: 87px; text-align: center">
                  <Clipboard :copytext="String(scope.row.id)">
                    <el-button type="text">内部链接</el-button>
                  </Clipboard>
                </div>
                <div style="display: inline-block; width: 87px; text-align: center">
                  <el-button @mousemove.native="openCopyLink" type="text">外部链接</el-button>
                </div>
              </div>
              <div v-show="showCopyLink && !linkLoading">
                <div v-if="linkUrls.length === 0" style="display: flex; justify-content: center">
                  暂无适用公众号
                </div>
                <div v-for="url in linkUrls" :key="url.agent_id">
                  <div
                    v-if="getAppName(url.agent_id)"
                    style="display: flex; justify-content: space-between; align-items: center"
                  >
                    <div>{{ getAppName(url.agent_id) }}</div>
                    <Clipboard :copytext="url.url">
                      <el-button type="text">复制</el-button>
                    </Clipboard>
                  </div>
                </div>
              </div>
            </div>
            <el-button
              slot="reference"
              type="text"
              @click="getLinkAddress(scope.row.id, 6)"
              style="margin-left: 10px"
            >
              链接
            </el-button>
          </el-popover>
          <el-button
            v-if="scope.row.status === 0"
            type="text"
            @click="putColStatus(scope.row.id)"
            style="margin-left: 10px"
          >
            上架
          </el-button>
          <el-button
            v-else
            type="text"
            @click="changColStatus(scope.row)"
            style="margin-left: 10px"
          >
            下架
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination_col">
      <el-pagination
        style="background-color: #ffffff; width: 100%"
        layout="total, prev,sizes, pager, next, jumper"
        :total="total"
        :page-sizes="g_pageSizesConfig"
        :page-size="form.limit"
        :current-page="form.page"
        @current-change="currentChange"
        @size-change="handleSizeChange"
      />
    </div>
    <el-dialog
      class="orange_dialog"
      :visible.sync="dialogVisible"
      :show-close="false"
      :center="true"
      width="376px"
    >
      <div>确定下架该内容吗</div>
      <div class="disable">（可从"发布状态-已下架"找到已下架内容）</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="setArticleStatus(6)">确 定</el-button>
      </span>
    </el-dialog>
    <ApplicationDialog
      v-if="applicationDialogVisible"
      v-model="applicationDialogVisible"
      ref="applicationDialog"
      :selected-article="selectArticleForApp"
      @closeDialog="applicationDialogVisible = false"
      @success="getArticleList"
    ></ApplicationDialog>
    <show-delete-mate
      :show="isShowDlete"
      :data="showMediaList"
      @affirm="confirmPublish"
      @close="isShowDlete = false"
    />
    <recordPop
      v-if="recordPopShow"
      :art-id="targetId"
      :push-type="1"
      origin="企业微信"
      @closeRecord="recordPopShow = false"
    />
    <el-dialog
      title="提示"
      :visible.sync="hintVoteForbidShow"
      :modal-append-to-body="true"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="600px"
    >
      <div class="hint_title">以下文章包含投票，在企业应用内无法正常显示，请编辑或重新选择。</div>
      <div class="no_pass_list">
        <p v-for="(item, index) in noPassList" :key="index">&#171; {{ item.title }} &#187;</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="hintVoteForbidShow = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  EyaoSaaSQueryArticlesApi,
  EyaoSaaSTakeDownArticlesApi,
  EyaoSaaSTakeUpArticlesApi,
  getDeletedMediaListApi,
  GetAllLabelInfoList,
} from '@/api/releaseManagement';
import { GetProductInfoList } from '@/api/setUser.js';
import { xor } from 'lodash';
import ApplicationDialog from '../components/ApplicationDialog.vue';
import recordPop from '../components/recordPop/index';
import showDeleteMate from '../articleEdit/components/showDeleteMate';
import { GetLinkAddress } from '@/api/artilceList';
import Clipboard from '@/components/Clipboard';
const selectLimit = 8;
export default {
  name: 'ArticleList',
  components: { ApplicationDialog, showDeleteMate, Clipboard, recordPop },
  // filters: {
  //   tagsName(val) {
  //     const item = this.tagsList.filter((it) => it.Id === val);
  //     return item.LabelName;
  //   },
  // },
  data() {
    return {
      tagsList: [], // 全部一维标签
      tagList: [], // 选中的标签
      options: [], // 二维标签,放下拉选择框里
      tabListName: {
        promoteList: 1,
        diseaseList: 2,
        otherTagList: 4,
      },
      tagProps: {
        multiple: true,
        value: 'Id',
        label: 'LabelName',
      },
      form: {
        status: '',
        title: '',
        author: '',
        limit: undefined,
        operate_time_begin: '',
        operate_time_end: '',
        page: 1,
      },
      searchTime: [],
      total: 0,
      pubulcList: [], // 发布账号列表
      // 1.未发布 2.发布中 3.已发布到公众号 4.已发布到小程序 5.已发布到公众号和小程序 6.已下架',
      statusList: [
        {
          label: '已发布',
          value: 2,
        },
        {
          label: '待发布',
          value: 1,
        },
        {
          label: '已下架',
          value: 0,
        },
      ], // 发布状态列表
      strategyList: [], // 发布策略列表
      tableData: [], // 表格数据
      productList: [], // 产品列表
      sortList: [], // 排序信息列表
      sortBoxVisible: false, // 排序盒子开关
      dialogVisible: false, // 弹窗
      statusData: {
        1: '未发布',
        2: '已发布',
        3: '发布中',
        0: '已下架',
      },
      selectLimit: 1,
      strategyForm: {
        strategy_name: '',
        page: 1,
        limit: 10,
      },
      pubulcForm: {
        app_name: '',
        page: 1,
        limit: 10,
      },
      loading: false,
      targetId: '',
      selectArticleForApp: {},
      applicationDialogVisible: false,
      isShowDlete: false, // 素材使用情况弹窗
      showMediaList: [], // 素材使用情况数据
      passAppArr: [],
      recordPopShow: false, // 记录弹窗
      copylink: '', // 用于复制链接
      showCopyLink: false,
      linkKeyword: '', // 当前查询链接的文章，用于节流
      linkUrls: [], // 复制链接-h5的数组
      linkSelfUrl: '', // 复制链接-文章本身的链接
      linkLoading: false, // loading遮罩，防止用户操作过快
      noPassList: [],
      hintVoteForbidShow: false,
    };
  },
  created() {
    this.form.limit = this.g_pageSizeDefault;

    this.getAllQueryPageTag();
    // 设置面包屑
    const breadcrumb = [
      { menu_name: '发布管理', menu_path: '' },
      {
        menu_name: '内容管理',
        menu_path: '',
      },
      { menu_name: '企业应用文章列表' },
    ];

    this.$store.commit('user/setBreadcrumb', breadcrumb);
  },
  methods: {
    // 获取全量标签
    getAllQueryPageTag() {
      const tagsList = [];

      // 查询产品标签
      GetProductInfoList({})
        .then((res) => {
          this.productList = res.list;
          // const product = {
          //   LabelName: '产品',
          //   Id: 'product',
          //   children: res.list.map((item) => {
          //     return {
          //       LabelName: item.product_name,
          //       Id: item.id,
          //       TagType: 1,
          //     };
          //   }),
          // };
          // this.options.push(product);
        })
        .catch((e) => {
          this.$message.error(e.message || e);
        });
      // // 查询科室列表
      // QueryHospitalDepartment('QueryHospitalDepartment')
      //   .then((res) => {
      //     const departemt = {
      //       LabelName: '科室',
      //       Id: 'departemt',
      //       children: res.data.map((item) => {
      //         return {
      //           LabelName: item.department_name,
      //           Id: item.department_id,
      //           TagType: 2,
      //         };
      //       }),
      //     };
      //     this.options.push(departemt);
      //   })
      //   .catch((e) => {
      //     this.$message.error(e.message || e);
      //   });

      GetAllLabelInfoList()
        .then((res) => {
          res.LabelGroupList.forEach((item) => {
            item.LabelList.forEach((it) => {
              tagsList.push(it);
            });
            this.options.push({
              LabelName: item.GroupName,
              Id: item.GroupName,
              children: item.LabelList.map((it) => {
                return { TagType: 3, ...it };
              }),
            });
          });
          this.tagsList = tagsList;
          this.getArticleList();
        })
        .catch((e) => {
          this.$message.error(e.message || e);
        });
    },
    viewRecord(row) {
      this.recordPopShow = true;
      this.targetId = row.id;
    },
    confirmPublish() {
      this.isShowDlete = false;
      this.openApplicationDialog();
    },
    // 获取已删除素材
    getDeletedMediaList() {
      return new Promise((reject) => {
        this.loading = true;
        const titleData = {};
        const artIds = [];
        this.sortList.forEach((e) => {
          titleData[e.id] = e.title;
          artIds.push(e.id.toString());
        });
        getDeletedMediaListApi({
          art_ids: artIds,
          art_type: 2,
        })
          .then((res) => {
            const { maps } = res;
            let mediaInfoArr = [];
            const showMediaList = [];
            for (const id in maps) {
              const mediaInfo = maps[id].media_info;
              const deletedMedia = maps[id].deleted_media;
              if (JSON.stringify(mediaInfo) !== '{}') {
                mediaInfoArr = mediaInfoArr.concat(mediaInfo);
              }
              if (JSON.stringify(deletedMedia) !== '{}' && JSON.stringify(deletedMedia) !== '[]') {
                // [{deleted_media:[],id:'',title:''}]
                showMediaList.push({
                  deleted_media: deletedMedia,
                  id,
                  title: titleData[id],
                });
              }
            }
            this.loading = false;
            const appData = {};
            const appList = [];
            mediaInfoArr.forEach((e) => {
              if (Array.isArray(e.agent_list) && e.agent_list.length) {
                e.agent_list.forEach((p) => {
                  if (appData[p.agent_id]) {
                    appData[p.agent_id].count += 1;
                  } else {
                    appData[p.agent_id] = {
                      count: 1,
                      item: p,
                    };
                  }
                });
              }
            });

            for (const key in appData) {
              const item = appData[key];
              if (item.count == mediaInfoArr.length) {
                appList.push(item.item);
              }
            }
            this.passAppArr = appList;
            if (showMediaList.length) {
              this.isShowDlete = true;
              this.showMediaList = showMediaList;
              return;
            }
            reject();
          })
          .catch((e) => {
            this.$message.error(e.message || e);
          });
      });
    },
    // 检查是否有投票
    checkAtricleIsHaveVote() {
      return new Promise((resolve, reject) => {
        return resolve();
        const noPassList = [];
        let flag = false;
        this.sortList.forEach((a) => {
          // 如果支持投票就就不准提交
          if (a.vote_support_opt == 1) {
            flag = true;
            noPassList.push(a);
          }
        });
        if (flag) {
          this.noPassList = noPassList;
          this.hintVoteForbidShow = true;
          reject();
        } else {
          resolve();
        }
      });
    },
    // 校验文章
    verifyArticleList() {
      if (this.sortList.length > selectLimit) {
        this.$message.error(`最多只能选择${selectLimit}篇`);
        return;
      }
      this.checkAtricleIsHaveVote()
        .then(() => {
          this.getDeletedMediaList().then(() => {
            this.openApplicationDialog();
          });
        })
        .catch(() => {});
    },
    // 上架
    putColStatus(id) {
      EyaoSaaSTakeUpArticlesApi({
        ids: [id],
      })
        .then(() => {
          this.$message({
            message: '上架成功',
            type: 'success',
          });
          this.getArticleList();
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    // 点击按钮【发布到企业应用】，打开弹窗
    openApplicationDialog() {
      this.selectArticleForApp = { ...this.sortList[0] };
      this.selectArticleForApp.art_agent_list = this.passAppArr;
      this.applicationDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.applicationDialog.setArticleSortList([...this.sortList]);
      });
    },
    // 修改状态
    changColStatus(row) {
      this.targetId = row.id;
      this.dialogVisible = true;
    },
    // 编辑
    editCol(row) {
      this.$emit('changeComponet', 'articleEditAgents', { id: row.id });
    },
    // 下架置灰
    tableRowDisabled({ row }) {
      if (row.status === 0) {
        return 'disabled_col';
      }
    },
    hanldeSelect() {},
    // 是否可选
    selectable(row) {
      return row.status !== 0;
    },
    // 触发选择
    handleSelectionChange(val) {
      // if (val.length > 1) {
      //   this.$refs.table.clearSelection();
      //   this.sortList = val.pop();
      //   this.$refs.table.toggleRowSelection(this.sortList);
      // } else {
      //   this.sortList = val;
      // }
      this.sortList = val;
    },
    handleSizeChange(val) {
      this.form.limit = val;
      this.getArticleList();
    },
    currentChange(val) {
      this.form.page = val;
      this.getArticleList();
    },
    // 搜索
    searchList() {
      // this.loading = true;
      this.form.page = 1;
      if (this.searchTime && this.searchTime.length) {
        // 接口使用的是秒
        [this.form.operate_time_begin, this.form.operate_time_end] = [
          this.searchTime[0].getTime() / 1000,
          this.searchTime[1].getTime() / 1000 + 86399,
        ];
      } else {
        [this.form.operate_time_begin, this.form.operate_time_end] = ['', ''];
      }
      this.getArticleList(() => {
        this.$message.closeAll();
        if (this.tableData.length) {
          this.$message.success('搜索成功！');
        } else {
          this.$message.warning('暂无数据');
        }
      });
      // this.loading = false;
    },
    // 获取文章列表
    getArticleList(cb) {
      this.loading = true;
      const form = { ...this.form };
      if (form.status === '') {
        form.status = -1;
      }
      const tags = [];
      if (this.tagList.length) {
        this.tagList.forEach((e) => {
          // tags.push({
          //   TagType: (() => {
          //     if (e[0] === 'product') {
          //       return 1;
          //     }
          //     if (e[0] === 'departemt') {
          //       return 2;
          //     }
          //     return 3;
          //   })(),
          //   TagId: e[1],
          // });
          tags.push(Number(e[1]));
        });
        form.tagList = tags;
      }
      EyaoSaaSQueryArticlesApi(form)
        .then((res) => {
          this.loading = false;
          this.tableData = res.list;

          this.tableData.forEach((item) => {
            item.tags = item.tags.filter((it) => it.TagType === 1);
            item.tags = this.productList.reduce((pre, cur) => {
              if (item.tags.some((item) => item.TagId === cur.id)) {
                pre.push(cur);
              }
              return pre;
            }, []);
          });
          this.total = res.total;
          if (cb) {
            cb();
          }
        })
        .catch((e) => {
          this.loading = false;
          this.$message.error(e.message);
        });
    },
    remoteSearchAccount(key) {
      this.pubulcForm.app_name = key;
      this.getAppList();
    },
    selectFocus(refName, arrName) {
      if (this[arrName].length === 0) {
        this.$refs[refName].remoteMethod();
      }
    },
    // 弹窗确认按钮
    setArticleStatus() {
      EyaoSaaSTakeDownArticlesApi({
        ids: [this.targetId],
      })
        .then(() => {
          this.getArticleList();
          this.dialogVisible = false;
          this.$message.success(`下架成功!`);
        })
        .catch((e) => {
          this.$message.error(e.message);
        });
    },
    // 返回
    createMessage() {
      this.$emit('changeComponet', 'articleEditAgents');
    },
    // 改变选择的栏
    changeSelceltRow(arr) {
      const diffArr = xor(arr, this.sortList);
      diffArr.forEach((row) => {
        this.$refs.table.toggleRowSelection(row, false);
      });
    },
    submitForm() {},
    getLinkAddress(id, type) {
      // 获取外部链接
      if (this.linkKeyword !== id) {
        this.linkKeyword = id;
        this.linkLoading = true;
        GetLinkAddress({
          type,
          key: id,
        })
          .then((res) => {
            // this.linkSelfUrl = res.url;
            this.linkUrls = res.h5_urls;
            this.linkLoading = false;
          })
          .catch((e) => {
            this.$message.error(e);
          });
      }
    },
    // 打开复制链接窗口
    openCopyLink() {
      if (!this.showCopyLink) {
        this.showCopyLink = true;
      }
    },
    // 关闭复制链接窗口
    closeCopyLink() {
      if (this.showCopyLink) {
        this.showCopyLink = false;
      }
    },
    getAppName(id) {
      for (const item of this.appList()) {
        if (item.agent_id === id) {
          return item.agent_name;
        }
      }
      return false;
    },
    appList() {
      // return this.$store.state.user.managerLogin.agent_list.map((item) => ({
      //   label: item.agent_name,
      //   value: item.agent_id,
      // }));
      return this.$store.state.user.managerLogin.agent_list;
    },
  },
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
